import {
  LOG_IN,
  LOG_OUT,
  AUTH_ERROR,
  SHOW_NOTIFICATION,
  HIDE_NOTIFICATION,
  SHOW_SPINNER,
  HIDE_SPINNER,
  RESET_CONFIG,
  RESET_COURSES,
  RESET_NOTES,
  RESET_COURSE_SECTIONS,
  RESET_EXERCISES,
  RESET_FILES,
  RESET_MESSAGES,
  RESET_USER_STATE,
  UPDATE_SESSION_ID,
  SESSION_MISMATCH,
  VIEW_USER_REPORTS,
} from "../types";
import api from "../../api";
import history from "../../history";
import { errHandler } from "./errHandler";

import { loadConfig, getUserState, getBackendStats } from "./index";
import buildInfo from "../../config/buildInfo.json";
import { getBuildNo } from "../../tools";

export const logIn = (user, pass) => async (dispatch) => {
  dispatch({ type: SHOW_SPINNER, payload: "Logowanie..." });
  const data = new FormData();
  data.set("username", user);
  data.set("password", pass);

  const options = {
    method: "post",
    data: data,
    url: "/login",
    withCredentials: true,
  };
  let response = {};
  try {
    response = await api(options);
    dispatch({ type: HIDE_NOTIFICATION });
    if (response.status === 200) {
      dispatch({ type: LOG_IN, user });
      dispatch(loadConfig());
      dispatch(getUserState());
    }
    updateAppIfRequired();
  } catch (e) {
    errHandler(e, dispatch, "Błąd logowania");
    let message;
    if (e.message.search("401") >= 0) {
      message = "Nieprawidłowy login lub hasło";
    } else {
      message = "Błąd sieci. Brak dostępu do internetu";
    }
    dispatch({
      type: AUTH_ERROR,
      payload: message,
    });
  }
  dispatch({ type: HIDE_SPINNER });
};

export const logOut = () => async (dispatch) => {
  dispatch({ type: SHOW_SPINNER, payload: "Good bye..." });
  const options = {
    method: "post",
    url: "/logout",
    withCredentials: true,
  };
  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    // Handle network errors
  }
  dispatch({ type: HIDE_SPINNER });
  clearAll(dispatch);
  if (response.status === 200) {
    // dispatch({
    //   type: SHOW_NOTIFICATION,
    //   payload: { message: 'Poprawnie wylogowano z platformy', type: 'info' }
    // });
    history.push("/login");
    updateAppIfRequired();
  } else {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: "Wystąpił problem z wylogowaniem", type: "error" },
    });
  }
};

export const sessionEnded = () => async (dispatch) => {
  clearAll(dispatch);
  dispatch({
    type: SHOW_NOTIFICATION,
    payload: {
      message: "Twoja sesja wygasła, wylogowano z platformy",
      type: "error",
    },
  });
  history.push("/login");
  updateAppIfRequired();
};

export const isLogged = () => async (dispatch) => {
  const options = {
    method: "get",
    url: "/user/setting/session",
    withCredentials: true,
  };
  let response = {};
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: "Zalogowano", type: "success" },
      });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { message: "Nie zalogowano", type: "error" },
      });
    }
  } catch (e) {
    dispatch({
      type: SHOW_NOTIFICATION,
      payload: { message: "Nie zalogowano", type: "error" },
    });
  }
};

export const authInit = () => async (dispatch) => {
  const options = {
    method: "get",
    url: "/user/setting/session",
    withCredentials: true,
  };
  let response = {};
  try {
    response = await api(options);
    if (response.status === 200) {
      const viewReportPrivilege = await hasViewReportPrivilege();
      dispatch({ type: LOG_IN });
      dispatch(loadConfig());
      dispatch(getUserState());
      dispatch(getBackendStats());
      dispatch({ type: VIEW_USER_REPORTS, payload: viewReportPrivilege });
    } else {
      dispatch({ type: LOG_OUT });
      history.push("/login");
    }
  } catch (e) {
    dispatch({ type: LOG_OUT });
    history.push("/login");
  }
};

export const clearState = () => (dispatch) => {
  clearAll(dispatch);
};

export const clearAll = (dispatch) => {
  dispatch({ type: LOG_OUT });
  dispatch({ type: RESET_CONFIG });
  dispatch({ type: RESET_COURSES });
  dispatch({ type: RESET_NOTES });
  dispatch({ type: RESET_COURSE_SECTIONS });
  dispatch({ type: RESET_EXERCISES });
  dispatch({ type: RESET_FILES });
  dispatch({ type: RESET_MESSAGES });
  dispatch({ type: RESET_USER_STATE });
};

export const checkSession = () => async (dispatch, getState) => {
  const auth = getState().auth;
  if (!auth.loggedIn) return;
  const currentId = auth.id;
  let response;
  try {
    response = await api.get("/user/setting/session", {
      withCredentials: true,
    });
    let sessionId = 0;
    if (response.status === 200) {
      try {
        const obj = JSON.parse(response.data.value);
        if (obj && obj.id) sessionId = obj.id;
      } catch (e) {}
      if (currentId !== sessionId) {
        dispatch({ type: SESSION_MISMATCH });
      }
    }
  } catch (e) {
    const msg = e.message;
    if (msg.indexOf("401") !== -1) {
      dispatch(logOut());
    } else if (msg.indexOf("Network Error") !== -1) {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: {
          message: "Wystąpił problem z połączeniem internetowym",
          type: "error",
        },
      });
    } else {
      // errHandler(e, dispatch, 'Błąd pobierania numeru sesji');
    }
  }
};

export const newSession = () => async (dispatch) => {
  const session = {
    id: getTimestamp(),
    ua: window.navigator.userAgent,
    lang: window.navigator.language,
  };
  const options = {
    method: "post",
    data: { code: "session", value: JSON.stringify(session) },
    url: "/user/setting",
    withCredentials: true,
  };

  let response;
  try {
    response = await api(options);
    if (response.status === 200) {
      dispatch({ type: UPDATE_SESSION_ID, id: session.id });
    } else {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: {
          message: "Błąd: konfiguracja nie została zapisana",
          type: "error",
        },
      });
    }
  } catch (e) {
    errHandler(e, dispatch, "Błąd zapisu sesji");
  }
};

function getTimestamp() {
  return Math.round(new Date().getTime() / 1000);
}

export const updateAppIfRequired = () => {
  const currentBuildNo = buildInfo.build;
  getBuildNo()
    .then((availableVersion) => {
      if (availableVersion !== currentBuildNo) {
        window.location.reload();
      }
    })
    .catch();
};

export const getPrivileges = async () => {
  const options = {
    method: "get",
    url: "/user/privilege ",
    withCredentials: true,
  };
  try {
    const response = await api(options);
    if (response.status === 200 && response.data && response.data.length) {
      return response.data.map((c) => c.code);
    }
  } catch (e) {
    console.log(e);
  }
  return [];
};

export const hasViewReportPrivilege = async () => {
  const privileges = await getPrivileges();
  return privileges.indexOf("jpalio.icr.report.student") !== -1;
};
